// extracted by mini-css-extract-plugin
export default {"wrapper":"OffersPage_wrapper__lbmpU","table":"OffersPage_table__1uTy7"};